import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { useFormContext } from '../Form';
import WeekDay from './WeekDay';
import weekDays from './weekDays';
import useRegisterInput from '../Form/useRegisterInput';

const OpeningHours = ({ name, label, value, onChange, register: shouldRegister }) => {
  useRegisterInput(name, shouldRegister);

  const intl = useIntl();
  const formContext = useFormContext();
  const { setValue, watch } = formContext || {};
  const inputValue = value ?? (watch && watch(name));

  const handleChange = field => (ev, newValue) => {
    if (formContext && !onChange) {
      setValue(name, newValue);
      return;
    }

    if (onChange) {
      onChange(ev, { ...value, [field]: newValue });
    }
  };

  const formattedWeekDays = weekDays.map(weekDay => {
    const weekDayLabel = intl.formatMessage({
      id: weekDay.translationKey,
      defaultMessage: weekDay.label,
      description: `Label of weekday ${weekDay.label}`,
    });

    return {
      key: weekDayLabel.substring(0, 2).toLowerCase(),
      label: weekDayLabel,
      shortLabel: weekDayLabel.substring(0, 2),
      value: weekDay.value,
      periods: [],
    };
  });

  return (
    <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
      <FormLabel component="legend">{label ?? name}</FormLabel>
      <Box py={1} display="grid" gridTemplateColumns="auto 1fr auto" alignItems="flex-start">
        {formattedWeekDays.map(formattedWeekDay => (
          <WeekDay
            key={`${name}.${formattedWeekDay.key}`}
            name={`${name}.${formattedWeekDay.key}`}
            weekDay={formattedWeekDay}
            onChange={handleChange(formattedWeekDay.key)}
            value={inputValue?.[formattedWeekDay.key]}
          />
        ))}
      </Box>
    </FormControl>
  );
};

OpeningHours.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  register: PropTypes.bool,
};

OpeningHours.defaultProps = {
  label: '',
  value: undefined,
  onChange: undefined,
  register: true,
};

export default OpeningHours;
